import type { ReactNode } from 'react';

import { cx } from '../../lib/cx';
import styles from './emptyState.module.css';

export interface EmptyStateProps {
  title: string;
  /** Что сделать дальше. Пустой экран без следующего шага — тупик. */
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/**
 * Пустое состояние списка.
 *
 * Иллюстраций нет намеренно (DESIGN.md, антислоп): картинка на кухонном экране —
 * это шум, а нужен ответ на вопрос «что делать». Отсюда обязательный заголовок
 * и рекомендуемое действие.
 */
export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cx(styles.root, className)}>
      <p className={styles.title}>{title}</p>
      {description ? <p className={styles.description}>{description}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
